import { extendTheme } from '@chakra-ui/react';

export const methodistTheme = extendTheme({
  colors: {
    methodist: {
      blue: '#003087',
      navy: '#002B49',
      white: '#FFFFFF',
      black: '#000000',
      lightBlue: '#7BA4D9',
      clinical: '#0066CC',
      green: '#4A8B71',
      orange: '#E67E22',
      red: '#C8102E',
    },
  },
  fonts: {
    heading: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    body: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    mono: '"JetBrains Mono", monospace',
  },
  styles: {
    global: {
      'html, body': {
        backgroundColor: 'white',
        color: 'black',
      },
      body: {
        bg: 'gray.50',
        color: 'gray.900',
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        color: 'methodist.blue',
        fontWeight: 'bold',
        mb: 6,
      },
    },
    Text: {
      baseStyle: {
        fontSize: 'md',
        lineHeight: 1.6,
      },
    },
    List: {
      baseStyle: {
        spacing: 3,
        fontSize: 'md',
      },
    },
    Container: {
      baseStyle: {
        maxW: '1200px',
        px: { base: 4, md: 8 },
        py: { base: 4, md: 6 },
      },
    },
    Button: {
      baseStyle: {
        fontWeight: 'semibold',
      },
      variants: {
        primary: {
          bg: 'methodist.navy',
          color: 'white',
          _hover: {
            bg: 'methodist.lightBlue',
          },
        },
        secondary: {
          bg: 'white',
          color: 'methodist.navy',
          border: '2px solid',
          borderColor: 'methodist.navy',
          _hover: {
            bg: 'methodist.lightBlue',
            color: 'white',
          },
        },
        methodist: {
          bg: 'methodist.blue',
          color: 'white',
          _hover: {
            bg: 'methodist.navy',
          },
        },
      },
    },
    Slide: {
      baseStyle: {
        bg: 'white',
        borderRadius: 'lg',
        boxShadow: 'lg',
        p: 8,
      },
    },
  },
  layerStyles: {
    slide: {
      bg: 'white',
      p: 8,
      borderRadius: 'md',
      boxShadow: 'sm',
    },
    titleSlide: {
      bg: 'methodist.navy',
      color: 'white',
      p: 12,
      textAlign: 'center',
    },
  },
  textStyles: {
    title: {
      fontSize: ['3xl', '4xl'],
      fontWeight: 'bold',
      lineHeight: 1.2,
      color: 'methodist.blue',
    },
    subtitle: {
      fontSize: ['xl', '2xl'],
      fontWeight: 'medium',
      lineHeight: 1.4,
    },
    bullet: {
      fontSize: 'md',
      lineHeight: 1.6,
      pl: 2,
    },
  },
});
